// Copyright (c) StrangeBee 2023

import React from 'react';
import { ReactElement } from 'react';
import { ReportTemplateWidgetType } from '../ReportTemplateManage';
import { TableWidget } from './TableWidget/TableWidget';
import { ReportTemplateWidgetEnum, SortOptions } from 'thehive-sdk';
import { THMarkdown } from '@Molecules/Inputs/THMarkdown/THMarkdown';
import { ListWidget } from './ListWidget/ListWidget';
import { ImageWidget } from './ImageWidget/ImageWidget';

export const widgetMap: Record<
    ReportTemplateWidgetType,
    | ((props: {
          reportTemplateId: string;
          _kind: ReportTemplateWidgetEnum;
          columns: string[];
          fangData?: boolean;
          sort?: SortOptions;
          filter?: any;
          template?: string;
          fields?: string[];
          logColumns?: string[];
          maxElements?: number;
          attachmentId?: string;
      }) => ReactElement)
    | null
> = {
    text: ({ template = '' }) => <THMarkdown disabled borderless value={template} />,
    image: (props) => <ImageWidget {...props} />,
    table: (props) => <TableWidget {...props} />,
    list: (props) => <ListWidget {...props} />,
};
